import { render, staticRenderFns } from "./SavedGoalContentPage.vue?vue&type=template&id=fccd02ec&scoped=true"
import script from "./SavedGoalContentPage.vue?vue&type=script&lang=js"
export * from "./SavedGoalContentPage.vue?vue&type=script&lang=js"
import style0 from "./SavedGoalContentPage.vue?vue&type=style&index=0&id=fccd02ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd02ec",
  null
  
)

export default component.exports